// HomeStyles.ts
import { styled } from "@mui/material/styles";

export const HomeRoot = styled("div")(({ theme }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
}));
